module.exports = __webpack_public_path__ + "static/media/love2.ac035abb.gif";